// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Matches — live-score cards, chip filters, token colors */

.match-display {
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  padding: 0 0 40px;
  color: var(--vb-text);
  box-sizing: border-box;
}

/* ---- Toolbar ---- */
.matches-toolbar {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 12px;
}

.matches-search {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 48px;
  padding: 0 6px 0 14px;
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 16px;
  box-shadow: var(--vb-shadow-sm);
  transition: border-color var(--vb-transition), box-shadow var(--vb-transition);
}

.matches-search svg {
  color: var(--vb-text-muted);
  flex-shrink: 0;
}

.matches-search input {
  flex: 1 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  color: var(--vb-text);
  font-size: 16px;
  padding: 10px 0;
}

.matches-search input::placeholder { color: var(--vb-text-muted); }
.matches-search input[type="search"]::-webkit-search-cancel-button { display: none; }

.matches-search:focus-within {
  border-color: var(--vb-primary);
  box-shadow: 0 0 0 3px var(--vb-primary-soft);
}

.search-clear {
  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: var(--vb-surface-2);
  color: var(--vb-text-muted);
}

.filter-toggle {
  position: relative;
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  border-radius: 12px;
  background: transparent;
  color: var(--vb-text-muted);
  cursor: pointer;
}
.filter-toggle:hover,
.filter-toggle.open {
  background: var(--vb-primary-soft);
  color: var(--vb-primary);
}

.filter-count {
  position: absolute;
  top: 4px;
  right: 4px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 999px;
  background: var(--vb-primary);
  color: var(--vb-primary-contrast);
  font-size: 10px;
  font-weight: 800;
  line-height: 16px;
  text-align: center;
}

.matches-chip-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.result-chips,
.sort-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.match-display .chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-height: 32px;
  padding: 4px 12px;
  border: 1px solid var(--vb-border);
  border-radius: 999px;
  background: var(--vb-surface);
  color: var(--vb-text-muted);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}
.match-display .chip:hover { color: var(--vb-text); background: var(--vb-surface-hover); }
.match-display .chip.active {
  background: var(--vb-navy);
  border-color: transparent;
  color: #fff;
}
body.night-mode .match-display .chip.active {
  background: var(--vb-primary);
  color: var(--vb-primary-contrast);
}

/* ---- Extra filters ---- */
.filters-panel {
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 16px;
  padding: 14px;
  margin-bottom: 12px;
  box-shadow: var(--vb-shadow-sm);
  animation: match-panel-in 0.18s ease;
}

@keyframes match-panel-in {
  from { opacity: 0; transform: translateY(-6px); }
  to { opacity: 1; transform: none; }
}

.filter-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  margin-bottom: 10px;
}

.filter-group { position: relative; }

.filter-group label {
  display: block;
  margin-bottom: 4px;
  font-weight: 700;
  color: var(--vb-text-muted);
  font-size: 11px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.filter-group input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--vb-border-strong);
  border-radius: 12px;
  font-size: 16px;
  background: var(--vb-surface-2);
  color: var(--vb-text);
  min-height: 44px;
  box-sizing: border-box;
}

.filter-group input:focus {
  outline: none;
  border-color: var(--vb-primary);
  box-shadow: 0 0 0 3px var(--vb-primary-soft);
}

.input-with-suggestions { position: relative; }

.suggestions {
  position: absolute;
  top: calc(100% - 4px);
  left: 0;
  right: 0;
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 0 0 12px 12px;
  z-index: 20;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: var(--vb-shadow);
}

.suggestion-item {
  display: block;
  width: 100%;
  text-align: left;
  padding: 12px;
  cursor: pointer;
  border: none;
  border-bottom: 1px solid var(--vb-border);
  background: transparent;
  color: var(--vb-text);
  font-size: 14px;
  font-weight: 650;
}
.suggestion-item:hover { background: var(--vb-surface-hover); }
.suggestion-item:last-child { border-bottom: none; }

.filter-actions { display: flex; justify-content: flex-end; }

.clear-btn {
  background: transparent;
  color: var(--vb-text-muted);
  border: none;
  min-height: 36px;
  padding: 6px 10px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
}
.clear-btn:hover { color: var(--vb-danger); background: var(--vb-danger-soft); }

.offline-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 36px;
  margin-bottom: 12px;
  padding: 6px 12px;
  border: 1px solid var(--vb-border);
  border-radius: 999px;
  background: var(--vb-warning-soft);
  color: var(--vb-text);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}
.offline-toggle.active {
  background: var(--vb-navy);
  border-color: transparent;
  color: #fff;
}

/* ---- Day groups ---- */
.match-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.match-day {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.match-day-label {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin: 0 4px;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--vb-text-muted);
}

.match-day-label span {
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}

/* ---- Score cards ---- */
.match-card {
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 18px;
  overflow: hidden;
  box-shadow: var(--vb-shadow-sm);
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.match-card.win { border-left: 3px solid var(--vb-primary); }
.match-card.loss { border-left: 3px solid var(--vb-border-strong); }
.match-card.tie { border-left: 3px solid var(--vb-warning); }

.match-card:hover {
  transform: translateY(-1px);
  box-shadow: var(--vb-shadow);
}

.match-card.selected {
  border-color: var(--vb-primary);
  box-shadow: 0 0 0 3px var(--vb-primary-soft);
}

.match-card.expanded {
  border-color: color-mix(in srgb, var(--vb-primary) 45%, var(--vb-border));
}

.offline-banner {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px 0;
  font-size: 11px;
  font-weight: 700;
  color: var(--vb-warning);
}
.offline-banner.failed { color: var(--vb-danger); }
.offline-banner.synced { color: var(--vb-success); }

.match-card-main {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  gap: 12px;
  align-items: center;
  width: 100%;
  padding: 12px 14px 8px;
  background: none;
  border: none;
  border-radius: 0;
  text-align: left;
  color: inherit;
  cursor: pointer;
}

.result-mark {
  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.result-mark.win {
  background: var(--vb-navy);
  color: #fff;
}
body.night-mode .result-mark.win {
  background: var(--vb-primary);
  color: var(--vb-primary-contrast);
}
.result-mark.loss {
  background: var(--vb-surface-2);
  color: var(--vb-text-muted);
  border: 1px solid var(--vb-border);
}
.result-mark.tie {
  background: var(--vb-warning-soft);
  color: #b45309;
}

.match-sides {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.side {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.side-name {
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 15px;
  font-weight: 700;
  color: var(--vb-text);
}

.side.lost .side-name,
.side.lost .side-score {
  color: var(--vb-text-muted);
  font-weight: 600;
}

.side-score {
  font-family: var(--vb-font-score);
  font-size: 30px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  line-height: 0.9;
  min-width: 1.35em;
  text-align: right;
  letter-spacing: -0.02em;
}

.side.won .side-score { color: var(--vb-text); }

.timeout-pips {
  display: inline-flex;
  gap: 3px;
  margin-left: 8px;
  flex-shrink: 0;
}

.timeout-pips i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--vb-border-strong);
}
.timeout-pips i.used { background: var(--vb-warning); }

.match-card-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 10px 10px 54px;
  flex-wrap: wrap;
}

.match-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  min-width: 0;
}

.match-chips span {
  padding: 3px 8px;
  border-radius: 999px;
  background: var(--vb-surface-2);
  color: var(--vb-text-muted);
  font-size: 11px;
  font-weight: 700;
}

.match-chips .chip-public {
  background: var(--vb-primary-soft);
  color: var(--vb-primary);
}

.match-note {
  margin: 0 14px 12px 54px;
  padding: 8px 10px;
  font-size: 13px;
  color: var(--vb-text-muted);
  background: var(--vb-surface-2);
  border-radius: 10px;
}

.match-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
  margin-left: auto;
}

.match-actions .icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: var(--vb-text-muted);
  cursor: pointer;
}
.match-actions .icon-btn:hover {
  background: var(--vb-surface-hover);
  color: var(--vb-text);
}
.match-actions .icon-btn.open,
.match-actions .icon-btn.on {
  background: var(--vb-primary-soft);
  color: var(--vb-primary);
}
.match-actions .icon-btn.danger:hover {
  background: var(--vb-danger-soft);
  color: var(--vb-danger);
}

/* ---- Rally / chart ---- */
.match-expanded {
  margin: 0 12px 12px;
  padding: 12px;
  border-top: 1px solid var(--vb-border);
  animation: match-panel-in 0.2s ease;
}

.rally-legend {
  display: flex;
  gap: 12px;
  margin-bottom: 8px;
  font-size: 11px;
  font-weight: 800;
}

.legend-a { color: var(--vb-team-a); }
.legend-b { color: var(--vb-team-b); }

.match-scoring-order {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  font-size: 12px;
}

.rally-tick {
  display: inline-grid;
  place-items: center;
  min-width: 22px;
  height: 24px;
  padding: 0 5px;
  border-radius: 6px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.rally-tick.team-a {
  background: color-mix(in srgb, var(--vb-team-a) 16%, var(--vb-surface));
  color: var(--vb-team-a);
}
.rally-tick.team-b {
  background: color-mix(in srgb, var(--vb-team-b) 16%, var(--vb-surface));
  color: var(--vb-team-b);
}
.rally-tick.timeout {
  background: var(--vb-warning-soft);
  color: #b45309;
}
.rally-tick.ace { box-shadow: inset 0 0 0 1.5px var(--vb-serve); }

.scoring-run {
  display: inline-flex;
  gap: 2px;
  padding: 2px;
  border-radius: 8px;
}
.scoring-run.run-a { background: color-mix(in srgb, var(--vb-team-a) 10%, transparent); }
.scoring-run.run-b { background: color-mix(in srgb, var(--vb-team-b) 10%, transparent); }

.score-chart {
  margin-top: 12px;
  background: var(--vb-surface-2);
  border-radius: 14px;
  padding: 12px 8px 4px;
  color: var(--vb-text-muted);
}

.score-chart h4 {
  text-align: left;
  margin: 0 8px 8px;
  color: var(--vb-text);
  font-size: 13px;
  font-weight: 800;
}

.custom-tooltip {
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  padding: 10px 12px;
  border-radius: 10px;
  color: var(--vb-text);
  box-shadow: var(--vb-shadow);
  font-size: 12px;
}

.custom-tooltip p { margin: 0 0 2px; }
.custom-tooltip .tooltip-lead { font-weight: 800; }

/* ---- States ---- */
.match-skeletons {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.match-skeleton {
  height: 108px;
  border-radius: 18px;
  background: linear-gradient(90deg, var(--vb-surface) 0%, var(--vb-surface-hover) 50%, var(--vb-surface) 100%);
  background-size: 200% 100%;
  animation: match-shimmer 1.2s ease infinite;
  border: 1px solid var(--vb-border);
}

@keyframes match-shimmer {
  from { background-position: 100% 0; }
  to { background-position: -100% 0; }
}

.loading-more {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 16px;
  color: var(--vb-text-muted);
  font-size: 13px;
  font-weight: 650;
}

.loading-spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid var(--vb-border);
  border-radius: 50%;
  border-top-color: var(--vb-primary);
  animation: match-spin 0.8s linear infinite;
}

@keyframes match-spin { to { transform: rotate(360deg); } }

.end-message {
  text-align: center;
  padding: 8px 0 4px;
  color: var(--vb-text-muted);
  font-size: 12px;
  font-weight: 650;
}

.empty-message {
  text-align: center;
  padding: 48px 16px;
  color: var(--vb-text-muted);
}

.empty-message svg {
  margin-bottom: 10px;
  opacity: 0.35;
}

.empty-message p {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 800;
  color: var(--vb-text);
}

.empty-message span { font-size: 13px; }

@media (min-width: 640px) {
  .filter-row { grid-template-columns: 1.4fr 1fr 1fr; }
  .side-score { font-size: 34px; }
  .side-name { font-size: 16px; }
  .match-card-foot { padding-left: 54px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/MatchDisplay.css"],"names":[],"mappings":"AAAA,2DAA2D;;AAE3D;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,+BAA+B;EAC/B,8EAA8E;AAChF;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,eAAe;AACjB;;AAEA,qCAAqC,2BAA2B,EAAE;AAClE,qEAAqE,aAAa,EAAE;;AAEpF;EACE,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;AACjB;AACA;;EAEE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,6BAA6B;EAC7B,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,oBAAoB;EACpB,6BAA6B;EAC7B,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,6BAA6B,qBAAqB,EAAE,mCAAmC,EAAE;AACzF;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA,4BAA4B;AAC5B;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA,gBAAgB,kBAAkB,EAAE;;AAEpC;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA,0BAA0B,kBAAkB,EAAE;;AAE9C;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,6BAA6B;EAC7B,kCAAkC;EAClC,4BAA4B;EAC5B,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,yCAAyC;EACzC,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;AACA,yBAAyB,mCAAmC,EAAE;AAC9D,8BAA8B,mBAAmB,EAAE;;AAEnD,kBAAkB,aAAa,EAAE,yBAAyB,EAAE;;AAE5D;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA,mBAAmB,uBAAuB,EAAE,iCAAiC,EAAE;;AAE/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kCAAkC;EAClC,oBAAoB;EACpB,kCAAkC;EAClC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,gFAAgF;AAClF;;AAEA,kBAAkB,wCAAwC,EAAE;AAC5D,mBAAmB,8CAA8C,EAAE;AACnE,kBAAkB,wCAAwC,EAAE;;AAE5D;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA,yBAAyB,uBAAuB,EAAE;AAClD,yBAAyB,wBAAwB,EAAE;;AAEnD;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,iCAAiC;AACnC;AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;AACpC;AACA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,wBAAwB,qBAAqB,EAAE;;AAE/C;EACE,oBAAoB;EACpB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mCAAmC;AACrC;AACA,uBAAuB,6BAA6B,EAAE;;AAEtD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,+BAA+B;EAC/B,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,2BAA2B;EAC3B,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;AACA;;EAEE,kCAAkC;EAClC,wBAAwB;AAC1B;AACA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,aAAa;EACb,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,YAAY,uBAAuB,EAAE;AACrC,YAAY,uBAAuB,EAAE;;AAErC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,uEAAuE;EACvE,uBAAuB;AACzB;AACA;EACE,uEAAuE;EACvE,uBAAuB;AACzB;AACA;EACE,kCAAkC;EAClC,cAAc;AAChB;AACA,kBAAkB,6CAA6C,EAAE;;AAEjE;EACE,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,kBAAkB;AACpB;AACA,qBAAqB,iEAAiE,EAAE;AACxF,qBAAqB,iEAAiE,EAAE;;AAExF;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,oBAAoB,eAAe,EAAE;AACrC,gCAAgC,gBAAgB,EAAE;;AAElD,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6GAA6G;EAC7G,0BAA0B;EAC1B,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,4BAA4B,EAAE;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA,wBAAwB,KAAK,yBAAyB,EAAE,EAAE;;AAE1D;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,sBAAsB,eAAe,EAAE;;AAEvC;EACE,cAAc,oCAAoC,EAAE;EACpD,cAAc,eAAe,EAAE;EAC/B,aAAa,eAAe,EAAE;EAC9B,mBAAmB,kBAAkB,EAAE;AACzC","sourcesContent":["/* Matches — live-score cards, chip filters, token colors */\n\n.match-display {\n  width: 100%;\n  max-width: 720px;\n  margin: 0 auto;\n  padding: 0 0 40px;\n  color: var(--vb-text);\n  box-sizing: border-box;\n}\n\n/* ---- Toolbar ---- */\n.matches-toolbar {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.matches-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 48px;\n  padding: 0 6px 0 14px;\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 16px;\n  box-shadow: var(--vb-shadow-sm);\n  transition: border-color var(--vb-transition), box-shadow var(--vb-transition);\n}\n\n.matches-search svg {\n  color: var(--vb-text-muted);\n  flex-shrink: 0;\n}\n\n.matches-search input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  color: var(--vb-text);\n  font-size: 16px;\n  padding: 10px 0;\n}\n\n.matches-search input::placeholder { color: var(--vb-text-muted); }\n.matches-search input[type=\"search\"]::-webkit-search-cancel-button { display: none; }\n\n.matches-search:focus-within {\n  border-color: var(--vb-primary);\n  box-shadow: 0 0 0 3px var(--vb-primary-soft);\n}\n\n.search-clear {\n  display: grid;\n  place-items: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: none;\n  border-radius: 50%;\n  background: var(--vb-surface-2);\n  color: var(--vb-text-muted);\n}\n\n.filter-toggle {\n  position: relative;\n  display: grid;\n  place-items: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border: none;\n  border-radius: 12px;\n  background: transparent;\n  color: var(--vb-text-muted);\n  cursor: pointer;\n}\n.filter-toggle:hover,\n.filter-toggle.open {\n  background: var(--vb-primary-soft);\n  color: var(--vb-primary);\n}\n\n.filter-count {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  min-width: 16px;\n  height: 16px;\n  padding: 0 4px;\n  border-radius: 999px;\n  background: var(--vb-primary);\n  color: var(--vb-primary-contrast);\n  font-size: 10px;\n  font-weight: 800;\n  line-height: 16px;\n  text-align: center;\n}\n\n.matches-chip-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.result-chips,\n.sort-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.match-display .chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  min-height: 32px;\n  padding: 4px 12px;\n  border: 1px solid var(--vb-border);\n  border-radius: 999px;\n  background: var(--vb-surface);\n  color: var(--vb-text-muted);\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.match-display .chip:hover { color: var(--vb-text); background: var(--vb-surface-hover); }\n.match-display .chip.active {\n  background: var(--vb-navy);\n  border-color: transparent;\n  color: #fff;\n}\nbody.night-mode .match-display .chip.active {\n  background: var(--vb-primary);\n  color: var(--vb-primary-contrast);\n}\n\n/* ---- Extra filters ---- */\n.filters-panel {\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 16px;\n  padding: 14px;\n  margin-bottom: 12px;\n  box-shadow: var(--vb-shadow-sm);\n  animation: match-panel-in 0.18s ease;\n}\n\n@keyframes match-panel-in {\n  from { opacity: 0; transform: translateY(-6px); }\n  to { opacity: 1; transform: none; }\n}\n\n.filter-row {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.filter-group { position: relative; }\n\n.filter-group label {\n  display: block;\n  margin-bottom: 4px;\n  font-weight: 700;\n  color: var(--vb-text-muted);\n  font-size: 11px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.filter-group input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid var(--vb-border-strong);\n  border-radius: 12px;\n  font-size: 16px;\n  background: var(--vb-surface-2);\n  color: var(--vb-text);\n  min-height: 44px;\n  box-sizing: border-box;\n}\n\n.filter-group input:focus {\n  outline: none;\n  border-color: var(--vb-primary);\n  box-shadow: 0 0 0 3px var(--vb-primary-soft);\n}\n\n.input-with-suggestions { position: relative; }\n\n.suggestions {\n  position: absolute;\n  top: calc(100% - 4px);\n  left: 0;\n  right: 0;\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 0 0 12px 12px;\n  z-index: 20;\n  max-height: 200px;\n  overflow-y: auto;\n  box-shadow: var(--vb-shadow);\n}\n\n.suggestion-item {\n  display: block;\n  width: 100%;\n  text-align: left;\n  padding: 12px;\n  cursor: pointer;\n  border: none;\n  border-bottom: 1px solid var(--vb-border);\n  background: transparent;\n  color: var(--vb-text);\n  font-size: 14px;\n  font-weight: 650;\n}\n.suggestion-item:hover { background: var(--vb-surface-hover); }\n.suggestion-item:last-child { border-bottom: none; }\n\n.filter-actions { display: flex; justify-content: flex-end; }\n\n.clear-btn {\n  background: transparent;\n  color: var(--vb-text-muted);\n  border: none;\n  min-height: 36px;\n  padding: 6px 10px;\n  border-radius: 10px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 700;\n}\n.clear-btn:hover { color: var(--vb-danger); background: var(--vb-danger-soft); }\n\n.offline-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 36px;\n  margin-bottom: 12px;\n  padding: 6px 12px;\n  border: 1px solid var(--vb-border);\n  border-radius: 999px;\n  background: var(--vb-warning-soft);\n  color: var(--vb-text);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.offline-toggle.active {\n  background: var(--vb-navy);\n  border-color: transparent;\n  color: #fff;\n}\n\n/* ---- Day groups ---- */\n.match-list {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.match-day {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.match-day-label {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin: 0 4px;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--vb-text-muted);\n}\n\n.match-day-label span {\n  font-variant-numeric: tabular-nums;\n  font-weight: 700;\n  letter-spacing: 0;\n  text-transform: none;\n}\n\n/* ---- Score cards ---- */\n.match-card {\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 18px;\n  overflow: hidden;\n  box-shadow: var(--vb-shadow-sm);\n  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;\n}\n\n.match-card.win { border-left: 3px solid var(--vb-primary); }\n.match-card.loss { border-left: 3px solid var(--vb-border-strong); }\n.match-card.tie { border-left: 3px solid var(--vb-warning); }\n\n.match-card:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--vb-shadow);\n}\n\n.match-card.selected {\n  border-color: var(--vb-primary);\n  box-shadow: 0 0 0 3px var(--vb-primary-soft);\n}\n\n.match-card.expanded {\n  border-color: color-mix(in srgb, var(--vb-primary) 45%, var(--vb-border));\n}\n\n.offline-banner {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px 0;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--vb-warning);\n}\n.offline-banner.failed { color: var(--vb-danger); }\n.offline-banner.synced { color: var(--vb-success); }\n\n.match-card-main {\n  display: grid;\n  grid-template-columns: 28px minmax(0, 1fr);\n  gap: 12px;\n  align-items: center;\n  width: 100%;\n  padding: 12px 14px 8px;\n  background: none;\n  border: none;\n  border-radius: 0;\n  text-align: left;\n  color: inherit;\n  cursor: pointer;\n}\n\n.result-mark {\n  display: grid;\n  place-items: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n}\n\n.result-mark.win {\n  background: var(--vb-navy);\n  color: #fff;\n}\nbody.night-mode .result-mark.win {\n  background: var(--vb-primary);\n  color: var(--vb-primary-contrast);\n}\n.result-mark.loss {\n  background: var(--vb-surface-2);\n  color: var(--vb-text-muted);\n  border: 1px solid var(--vb-border);\n}\n.result-mark.tie {\n  background: var(--vb-warning-soft);\n  color: #b45309;\n}\n\n.match-sides {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.side {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.side-name {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--vb-text);\n}\n\n.side.lost .side-name,\n.side.lost .side-score {\n  color: var(--vb-text-muted);\n  font-weight: 600;\n}\n\n.side-score {\n  font-family: var(--vb-font-score);\n  font-size: 30px;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  line-height: 0.9;\n  min-width: 1.35em;\n  text-align: right;\n  letter-spacing: -0.02em;\n}\n\n.side.won .side-score { color: var(--vb-text); }\n\n.timeout-pips {\n  display: inline-flex;\n  gap: 3px;\n  margin-left: 8px;\n  flex-shrink: 0;\n}\n\n.timeout-pips i {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--vb-border-strong);\n}\n.timeout-pips i.used { background: var(--vb-warning); }\n\n.match-card-foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 0 10px 10px 54px;\n  flex-wrap: wrap;\n}\n\n.match-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  min-width: 0;\n}\n\n.match-chips span {\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: var(--vb-surface-2);\n  color: var(--vb-text-muted);\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.match-chips .chip-public {\n  background: var(--vb-primary-soft);\n  color: var(--vb-primary);\n}\n\n.match-note {\n  margin: 0 14px 12px 54px;\n  padding: 8px 10px;\n  font-size: 13px;\n  color: var(--vb-text-muted);\n  background: var(--vb-surface-2);\n  border-radius: 10px;\n}\n\n.match-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  align-items: center;\n  margin-left: auto;\n}\n\n.match-actions .icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  border: none;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--vb-text-muted);\n  cursor: pointer;\n}\n.match-actions .icon-btn:hover {\n  background: var(--vb-surface-hover);\n  color: var(--vb-text);\n}\n.match-actions .icon-btn.open,\n.match-actions .icon-btn.on {\n  background: var(--vb-primary-soft);\n  color: var(--vb-primary);\n}\n.match-actions .icon-btn.danger:hover {\n  background: var(--vb-danger-soft);\n  color: var(--vb-danger);\n}\n\n/* ---- Rally / chart ---- */\n.match-expanded {\n  margin: 0 12px 12px;\n  padding: 12px;\n  border-top: 1px solid var(--vb-border);\n  animation: match-panel-in 0.2s ease;\n}\n\n.rally-legend {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 8px;\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.legend-a { color: var(--vb-team-a); }\n.legend-b { color: var(--vb-team-b); }\n\n.match-scoring-order {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3px;\n  font-size: 12px;\n}\n\n.rally-tick {\n  display: inline-grid;\n  place-items: center;\n  min-width: 22px;\n  height: 24px;\n  padding: 0 5px;\n  border-radius: 6px;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n}\n\n.rally-tick.team-a {\n  background: color-mix(in srgb, var(--vb-team-a) 16%, var(--vb-surface));\n  color: var(--vb-team-a);\n}\n.rally-tick.team-b {\n  background: color-mix(in srgb, var(--vb-team-b) 16%, var(--vb-surface));\n  color: var(--vb-team-b);\n}\n.rally-tick.timeout {\n  background: var(--vb-warning-soft);\n  color: #b45309;\n}\n.rally-tick.ace { box-shadow: inset 0 0 0 1.5px var(--vb-serve); }\n\n.scoring-run {\n  display: inline-flex;\n  gap: 2px;\n  padding: 2px;\n  border-radius: 8px;\n}\n.scoring-run.run-a { background: color-mix(in srgb, var(--vb-team-a) 10%, transparent); }\n.scoring-run.run-b { background: color-mix(in srgb, var(--vb-team-b) 10%, transparent); }\n\n.score-chart {\n  margin-top: 12px;\n  background: var(--vb-surface-2);\n  border-radius: 14px;\n  padding: 12px 8px 4px;\n  color: var(--vb-text-muted);\n}\n\n.score-chart h4 {\n  text-align: left;\n  margin: 0 8px 8px;\n  color: var(--vb-text);\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.custom-tooltip {\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  padding: 10px 12px;\n  border-radius: 10px;\n  color: var(--vb-text);\n  box-shadow: var(--vb-shadow);\n  font-size: 12px;\n}\n\n.custom-tooltip p { margin: 0 0 2px; }\n.custom-tooltip .tooltip-lead { font-weight: 800; }\n\n/* ---- States ---- */\n.match-skeletons {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.match-skeleton {\n  height: 108px;\n  border-radius: 18px;\n  background: linear-gradient(90deg, var(--vb-surface) 0%, var(--vb-surface-hover) 50%, var(--vb-surface) 100%);\n  background-size: 200% 100%;\n  animation: match-shimmer 1.2s ease infinite;\n  border: 1px solid var(--vb-border);\n}\n\n@keyframes match-shimmer {\n  from { background-position: 100% 0; }\n  to { background-position: -100% 0; }\n}\n\n.loading-more {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 16px;\n  color: var(--vb-text-muted);\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.loading-spinner {\n  display: inline-block;\n  width: 18px;\n  height: 18px;\n  border: 2px solid var(--vb-border);\n  border-radius: 50%;\n  border-top-color: var(--vb-primary);\n  animation: match-spin 0.8s linear infinite;\n}\n\n@keyframes match-spin { to { transform: rotate(360deg); } }\n\n.end-message {\n  text-align: center;\n  padding: 8px 0 4px;\n  color: var(--vb-text-muted);\n  font-size: 12px;\n  font-weight: 650;\n}\n\n.empty-message {\n  text-align: center;\n  padding: 48px 16px;\n  color: var(--vb-text-muted);\n}\n\n.empty-message svg {\n  margin-bottom: 10px;\n  opacity: 0.35;\n}\n\n.empty-message p {\n  margin: 0 0 4px;\n  font-size: 16px;\n  font-weight: 800;\n  color: var(--vb-text);\n}\n\n.empty-message span { font-size: 13px; }\n\n@media (min-width: 640px) {\n  .filter-row { grid-template-columns: 1.4fr 1fr 1fr; }\n  .side-score { font-size: 34px; }\n  .side-name { font-size: 16px; }\n  .match-card-foot { padding-left: 54px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
